import dayjs from 'dayjs';

import { CodefCertificateRaw, RefinedCodefCert } from '~types/codef';

import getCertInfo from './getCertInfo';

/**
 * 공동인증서의 raw 데이터를 화면에 노출을 위한 데이터로 변경
 * @param rawData
 * @returns
 */
export default function getRefinedCertData(rawData: CodefCertificateRaw): RefinedCodefCert;
export default function getRefinedCertData(rawData: CodefCertificateRaw[]): RefinedCodefCert[];
export default function getRefinedCertData(rawData: CodefCertificateRaw | CodefCertificateRaw[]) {
  if (Array.isArray(rawData)) {
    return rawData.map((raw) => parseRefinedData(raw));
  }

  return parseRefinedData(rawData);
}

function parseRefinedData(rawData: CodefCertificateRaw): RefinedCodefCert {
  const certificateOwner = rawData['cert.subjectname.CN'];
  const { usetype, organization } = getCertInfo(rawData['cert.extension.policyid']);
  const time = rawData['cert.validity.notAfter'];
  const certificateExpireDate = dayjs(time * 1000).format('YYYY-MM-DD');
  const isExpired = dayjs().diff(certificateExpireDate, 'd') > 0;

  return {
    certificateOwner,
    certificateType: usetype,
    certificateAuthority: organization,
    certificateExpireDate,
    status: isExpired ? 'EXPIRED' : 'NORMAL',
    raw: rawData,
  };
}
